export const resetPwdReqErrorInformation: { [id: string]: string } = {
  userDoesNotExist: "User does not exist",
  userExistOnBAButNotVerified: "User is not verified by Takeda",
  errorInGettingRecoveryToken: "Error in getting recovery token",
};
